<template>
  <div>
    <h4 class="px-3 py-4 m-0 text-center">
      {{ compData.component ? compData.component.item.ItemCode : "Nuevo Componente" }}
    </h4>
    <div class="row px-3 py-1">
      <div class="col-12">
        <p class="text-xs font-weight-bold mb-1">Producto *</p>
        <multiselect
          v-model="form.item"
          :options="filteredComponents"
          :loading="!components"
          :customLabel="(x) => `${x.ItemCode} ${x.ItemName}`"
          class="mb-4 small-multiselect"
          placeholder="Seleccionar Producto"
          :show-labels="false"
          :allow-empty="false"
          :options-limit="20"
        >
          <template #option="{option}">
            <b>{{ option.ItemCode }}</b>
            <br />
            <span>{{ option.ItemName }}</span>
          </template>
          <template #singleLabel="{option}">
            <b>{{ option.ItemCode }}</b>
            <br />
            <span>{{ option.ItemName }}</span>
          </template>
        </multiselect>
      </div>
      <div class="col-6">
        <p class="text-xs font-weight-bold mb-1">Almacén *</p>
        <multiselect
          v-model="form.Warehouse"
          :options="warehouses || []"
          :loading="!warehouses"
          class="mb-4 small-multiselect"
          placeholder="Seleccionar Almacén"
          :show-labels="false"
          :allow-empty="false"
        />
      </div>
      <div class="col-6">
        <p class="text-xs font-weight-bold mb-1">Cantidad Base *</p>
        <base-input
          v-model="form.BaseQuantity"
          type="number"
          placeholder="Cantidad Base"
          inputClasses="input-group-alternative form-control-sm text-xs"
          class="mb-4"
          min="1"
          @input="calculatePlannedQty"
        />
      </div>
      <div class="col-6">
        <p class="text-xs font-weight-bold mb-1">Cantidad Adicional *</p>
        <base-input
          v-model="form.AdditionalQuantity"
          type="number"
          placeholder="Cantidad Adicional"
          inputClasses="input-group-alternative form-control-sm text-xs"
          class="mb-4"
          min="0"
          @input="calculatePlannedQty"
        />
      </div>
      <div class="col-6">
        <p class="text-xs font-weight-bold mb-1">Cantidad Planificada *</p>
        <base-input
          v-model="form.PlannedQuantity"
          type="number"
          placeholder="Cantidad Planificada"
          inputClasses="input-group-alternative form-control-sm text-xs"
          class="mb-4"
          min="1"
          disabled
        />
      </div>
    </div>

    <div v-if="compData.component" class="d-flex flex-column mx-8 mt-3">
      <div
        v-b-popover.hover.focus.bottom.html="popoverData"
        class="mb-4"
        tabindex="0"
      >
        <base-button
          @click="$emit('saveChanges', form)"
          :disabled="!validation.valid"
          class="m-0 w-100"
          type="primary"
          size="sm"
        >
          Guardar Cambios
        </base-button>
      </div>
      <base-button
        @click="$emit('remove', form.item.ItemCode)"
        type="primary"
        outline
        size="sm"
      >
        Eliminar
      </base-button>
    </div>
    <div v-else class="d-flex flex-column mx-8 mt-3">
      <div
        v-b-popover.hover.focus.bottom.html="popoverData"
        tabindex="0"
        class="mb-4"
      >
        <base-button
          @click="$emit('addNew', form)"
          :disabled="!validation.valid"
          class="m-0 w-100"
          type="primary"
          size="sm"
        >
          Agregar Nuevo
        </base-button>
      </div>

      <base-button @click="$emit('close')" type="primary" outline size="sm">
        Cancelar
      </base-button>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
export default {
  components: {
    Multiselect,
  },
  props: {
    compData: Object,
    components: Array,
    warehouses: Array,
  },
  data() {
    return {
      show: false,
      form: {
        item: null,
        Warehouse: null,
        BaseQuantity: 0,
        AdditionalQuantity: 0,
        PlannedQuantity: 0,
      },
    };
  },
  created() {
    const component = this.compData.component;
    if (component) {
      this.form = {
        item: component.item || null,
        Warehouse: component.Warehouse || null,
        BaseQuantity: component.BaseQuantity || 0,
        AdditionalQuantity: component.AdditionalQuantity || 0,
        PlannedQuantity: component.PlannedQuantity || 0,
      };
    }
  },
  methods: {
    toggle() {
      this.show = !this.show;
    },
    calculatePlannedQty(){
      const firstPlannedQty = this.compData.firstPlannedQty;
      const { BaseQuantity, AdditionalQuantity } = this.form;
      this.form.PlannedQuantity = (
        (parseFloat(firstPlannedQty || 0 ) * parseFloat(BaseQuantity || 0) ) + parseFloat(AdditionalQuantity || 0)
      ).toFixed(5);
    }
  },
  computed: {
    filteredComponents() {
      return this.components.filter(x => !this.compData.addedComponents.includes(x.ItemCode));
    },
    validation() {
      const { item, Warehouse, BaseQuantity, AdditionalQuantity, PlannedQuantity } = this.form;
      const complete = {
        Producto: item,
        Almacén: Warehouse,
        "Cantidad Base (Mayor a 0)": BaseQuantity > 0,
        "Cantidad Adicional": AdditionalQuantity >= 0 && AdditionalQuantity !== '',
        "Cantidad Planificada (Mayor a 0)": PlannedQuantity > 0,
      };
      return {
        valid: Object.values(complete).every((x) => x),
        missing: Object.keys(complete).filter((x) => !complete[x]),
      };
    },
    popoverData() {
      if (this.validation.missing.length > 0) {
        return {
          title: "<small><b>Falta completar los campos:</b></small>",
          content: `<ul><li>${this.validation.missing.join("<li>")}</ul>`,
          placement: "righttop",
        };
      } else {
        return null;
      }
    },
  },
};
</script>

<style></style>
